(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-product-blocks"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('trc-product-blocks')) {
  customElements.define('trc-product-blocks', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-thumbnail]').forEach(button => {
        button.addEventListener('click', () => this.showPhoto(button.dataset.thumbnail));
      });
      const sizeLink = this.querySelector('[data-size-open]');
      const sizeDialog = this.querySelector('[data-size-dialog]');
      if (sizeLink && sizeDialog && typeof sizeDialog.showModal === 'function') {
        sizeLink.setAttribute('aria-haspopup', 'dialog');
        sizeLink.setAttribute('aria-controls', sizeDialog.id);
        sizeLink.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!sizeDialog.open) sizeDialog.showModal();
        });
        sizeDialog.querySelector('[data-size-close]').addEventListener('click', () => sizeDialog.close());
        sizeDialog.addEventListener('click', event => {
          if (event.target !== sizeDialog) return;
          const box = sizeDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) {
            sizeDialog.close();
          }
        });
        sizeDialog.addEventListener('close', () => sizeLink.focus({ preventScroll: true }));
      }
      const returnsLink = this.querySelector('[data-returns-open]');
      const returnsDialog = this.querySelector('[data-returns-dialog]');
      if (returnsLink && returnsDialog && typeof returnsDialog.showModal === 'function') {
        returnsLink.setAttribute('aria-haspopup', 'dialog');
        returnsLink.setAttribute('aria-controls', returnsDialog.id);
        returnsLink.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!returnsDialog.open) returnsDialog.showModal();
        });
        returnsDialog.querySelector('[data-returns-close]').addEventListener('click', () => returnsDialog.close());
        returnsDialog.addEventListener('click', event => {
          if (event.target !== returnsDialog) return;
          const box = returnsDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) {
            returnsDialog.close();
          }
        });
        returnsDialog.addEventListener('close', () => returnsLink.focus({ preventScroll: true }));
      }
      const selector = this.querySelector('[data-variant]');
      if (!selector) return;
      selector.addEventListener('change', () => {
        const option = selector.selectedOptions[0];
        if (!option) return;
        const price = this.querySelector('.trc-product__price [data-price]');
        if (price) price.textContent = option.dataset.price;
        const compare = this.querySelector('.trc-product__price [data-compare]');
        if (compare) {
          compare.textContent = option.dataset.compare;
          compare.hidden = !option.dataset.compare;
        }
        const available = option.dataset.available === 'true';
        const button = this.querySelector('[data-add]');
        if (button) {
          button.disabled = !available;
          button.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        }
        const availability = this.querySelector('[data-availability]');
        const unavailable = this.querySelector('[data-unavailable-text]');
        if (availability && unavailable) availability.textContent = available ? '' : unavailable.textContent;
        if (option.dataset.image) this.showPhoto(option.dataset.image);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        if (!window.Shopify?.designMode) window.history.replaceState({}, '', url);
      });
    }
    showPhoto(id) {
      const pictures = Array.from(this.querySelectorAll('[data-photo]'));
      if (!pictures.some(picture => picture.dataset.photo === id)) return;
      pictures.forEach(picture => { picture.hidden = picture.dataset.photo !== id; });
      this.querySelectorAll('[data-thumbnail]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.thumbnail === id));
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('trc-product')) {
  customElements.define('trc-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-thumbnail]').forEach(button => {
        button.addEventListener('click', () => this.showPhoto(button.dataset.thumbnail));
      });
      const sizeLink = this.querySelector('[data-size-open]');
      const sizeDialog = this.querySelector('[data-size-dialog]');
      if (sizeLink && sizeDialog && typeof sizeDialog.showModal === 'function') {
        sizeLink.setAttribute('aria-haspopup', 'dialog');
        sizeLink.setAttribute('aria-controls', sizeDialog.id);
        sizeLink.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!sizeDialog.open) sizeDialog.showModal();
        });
        sizeDialog.querySelector('[data-size-close]').addEventListener('click', () => sizeDialog.close());
        sizeDialog.addEventListener('click', event => {
          if (event.target !== sizeDialog) return;
          const box = sizeDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) {
            sizeDialog.close();
          }
        });
        sizeDialog.addEventListener('close', () => sizeLink.focus({ preventScroll: true }));
      }
      const returnsLink = this.querySelector('[data-returns-open]');
      const returnsDialog = this.querySelector('[data-returns-dialog]');
      if (returnsLink && returnsDialog && typeof returnsDialog.showModal === 'function') {
        returnsLink.setAttribute('aria-haspopup', 'dialog');
        returnsLink.setAttribute('aria-controls', returnsDialog.id);
        returnsLink.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!returnsDialog.open) returnsDialog.showModal();
        });
        returnsDialog.querySelector('[data-returns-close]').addEventListener('click', () => returnsDialog.close());
        returnsDialog.addEventListener('click', event => {
          if (event.target !== returnsDialog) return;
          const box = returnsDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) {
            returnsDialog.close();
          }
        });
        returnsDialog.addEventListener('close', () => returnsLink.focus({ preventScroll: true }));
      }
      const selector = this.querySelector('[data-variant]');
      if (!selector) return;
      selector.addEventListener('change', () => {
        const option = selector.selectedOptions[0];
        if (!option) return;
        this.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = this.querySelector('[data-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        const available = option.dataset.available === 'true';
        const button = this.querySelector('[data-add]');
        button.disabled = !available;
        button.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.querySelector('[data-availability]').textContent = available ? '' : this.querySelector('[data-unavailable-text]').textContent;
        if (option.dataset.image) this.showPhoto(option.dataset.image);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    }
    showPhoto(id) {
      const pictures = Array.from(this.querySelectorAll('[data-photo]'));
      if (!pictures.some(picture => picture.dataset.photo === id)) return;
      pictures.forEach(picture => { picture.hidden = picture.dataset.photo !== id; });
      this.querySelectorAll('[data-thumbnail]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.thumbnail === id));
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
